
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElTable } from 'element-plus'

export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const selectedRows = ref<any[]>([])

    const getSelectionRows = () => {
      return selectedRows.value || []
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        selectedRows.value = []
      }
    }
    const handleSelectionChange = (val: any) => {
      selectedRows.value = val
    }
    return {
      t,
      tableRef,
      handleSelectionChange,
      getSelectionRows,
      clearSelection
    }
  }
})
